<template>
  <section class="bg-[#a66439] overflow-hidden">
    <div
      class="relative flex flex-col md:flex-row items-center justify-center min-h-[380px] max-w-4xl mx-auto px-4 py-12 bg-[#a66439]"
    >
      <div class="flex-1 flex flex-col items-start justify-center z-10">
        <h2 class="text-white font-extrabold text-xl mb-6 leading-tight">
          {{ props.heading }}<br />
          <span class="text-[#fff] bg-[#2D1B15] px-2 rounded">{{ props.highlight }}</span>
          {{ props.subheading }}
        </h2>
        <button
          @click="handleButtonClick"
          class="bg-[#2D1B15] text-white font-semibold px-6 py-3 rounded-lg shadow hover:bg-[#3a241c] transition flex items-center gap-2 mb-2"
        >
          {{ props.buttonText }}
          <span class="inline-block transform rotate-45">→</span>
        </button>
      </div>

      <!-- Right Content -->
      <div class="flex-1 flex items-center justify-center relative z-10 mt-8 md:mt-0">
        <!-- Phone Image -->
        <img
          :src="getImageUrl(props.phoneImage)"
          alt="Phone Mockup"
          class="w-64 md:w-80 h-auto rounded-xl z-10 relative"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { getImageUrl } from '@/utils/image'
import { useRouter } from 'vue-router'

const router = useRouter()

const props = withDefaults(
  defineProps<{
    heading?: string
    highlight?: string
    subheading?: string
    buttonText?: string
    phoneImage?: string
    cardImage?: string
  }>(),
  {
    phoneImage: '@/assets/images/couple.png',
  },
)

const handleButtonClick = () => {
  router.push('/events')
}
</script>
